import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import LegalPage from "@/pages/LegalPage";
import "@/App.css";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="min-h-screen bg-white text-navy-950">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/privacy" element={<LegalPage slug="privacy" />} />
                    <Route path="/cookie-policy" element={<LegalPage slug="cookie" />} />
                    <Route path="/termini" element={<LegalPage slug="termini" />} />
                    <Route path="/contatti" element={<LegalPage slug="contatti" />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" theme="dark" />
        </div>
    );
}

export default App;
